import { render, staticRenderFns } from "./bkrefee.vue?vue&type=template&id=a9802612&scoped=true"
import script from "./bkrefee.vue?vue&type=script&lang=js"
export * from "./bkrefee.vue?vue&type=script&lang=js"
import style0 from "./bkrefee.vue?vue&type=style&index=0&id=a9802612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9802612",
  null
  
)

export default component.exports